import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal, Drawer, Button, Tabs, Row, Col, Spin, message, Input } from 'antd';
import { isEqual } from 'lodash';
import { callApi } from '../../utils/callApi/rest';
import SelectUserAndDept from './components/SelectUserAndDept';
import SelectPosition from './components/SelectPosition';
import SelectBusiness from './components/SelectBusiness';
import SelectLevel from './components/SelectLevel';
import SelectLabel from './components/SelectLabel';
import SelectDepartment from './components/SelectDepartment';
import SelectManager from './components/SelectManager';
import SelectVariable from './components/SelectVariable';
import SelectUser from './components/SelectUser';
import SelectSingleUser from './components/SelectSingleUser/index.js';
import ResultTable from './components/ResultTable';
import SelectApplierRelated from './components/SelectApplierRelated';
import './index.less';
import SelectStore from './context';

const TabPane = Tabs.TabPane;
const noop = () => {};
const { Search } = Input;
const valueOfmanageSceneFlag = (value) => {
	if (value) {
		return Number(value);
	}
	return undefined;
};

// 默认标题
const titleDict = {
	person: '选择用户',
	user: '选择用户',
	department: '选择部门',
	userAndDepartment: '选择部门/用户',
	position: '选择岗位',
	level: '选择职级',
	label: '选择标签',
};

// 查询组件类型
const componentType = {
	USER: 'user',
	DEPARTMENT: 'department',
	STATION: 'station',
	ALL: 'all',
};

const globalSingleSelectErrorMessage = () => {
	message.warning({
		key: 'error',
		content: '只能选择一个对象'
	});
};

class SelectModal extends Component {
	constructor (props) {
		super(props);
		this.state = {
			// organizations: null,
			// 确定按钮 loading
			confirmLoading: false,
			// 团队名字
			teamName: '',
			//选人内容区域 loading
			loading: props.loading,
			appId: window.$$context.appId,
			newSelects: props.selects || [],
			disabledSelects: props.disabledSelects,
			isLazyLoadData: undefined, // 是否使用对数据进行懒加载的功能
			origin: props.origin || '',
			communityId: props.communityId || '',
			hasLoaded: false, // 判断是否加载过接口
		};
		this.organizationMap = new Map();
	}

	async componentDidMount () {
		const { isLazyLoadData } = this.state;
		if (typeof isLazyLoadData === 'undefined') {
			await this.getLazyLoadConfig();
		}
		const { organizationId } = this.props;
		if (organizationId) {
			this.getOrganization(organizationId);
		}
	}

	componentWillReceiveProps (nextProps) {
		const { organizationId, visible, forceRefresh, selects, loading, disabledSelects, communityId } = this.props;
		const { confirmLoading, hasLoaded } = this.state;
		if (organizationId !== nextProps.organizationId && nextProps.organizationId) {
			this.getOrganization(nextProps.organizationId);
		}
		if (!isEqual(selects, nextProps.selects)) {
			this.setState({ newSelects: nextProps.selects || [] });
		}
		if (!isEqual(disabledSelects, nextProps.disabledSelects)) {
			this.setState({ disabledSelects: nextProps.disabledSelects });
		}
		if (!isEqual(loading, nextProps.loading)) {
			this.setState({ loading: nextProps.loading });
		}
		//关闭组件时清空数据
		if (visible !== nextProps.visible && !nextProps.visible) {
			this.setState({ newSelects: nextProps.selects || [], disabledSelects: nextProps.disabledSelects });
		}
		if (visible !== nextProps.visible && nextProps.visible) {
			// 当弹窗要显示且 forceRefresh 为true时，重新获取数据
			if (!hasLoaded || forceRefresh) {
				this.setState({
					hasLoaded: true,
				}, () => {
					this.state.origin ? this.getUserCommunity(nextProps.communityId) : this.getOrganization(nextProps.organizationId);
				});
			}
			// 当弹窗要显示且 confirmLoading 为true时，将其设为false
			if (confirmLoading) {
				this.setState({ confirmLoading: false });
			}
		}
	}

	getUserCommunity = (communityId) => {
		this.setState({
			treeLoading: true,
			communityId,
		}, () => {
			this.listUserCommunity().then((list) => {
				const obj = list.find(i => i.id + '' === communityId + '') ?? {};
				this.setState({
					teamName: obj?.name ?? '',
				}, this.getOrganization);
			});
		});
	};

	listUserCommunity = () => {
		const { organizationId } = this.props;
		return callApi({
			api: '/saleoppty/listOpportunityGroup',
			data: {
				organizationId
			},
		});
	};

	/**
	 * 获取是否执行懒加载的配置
	 */
	async getLazyLoadConfig() {
		return callApi({
			api: '/org_v6/getOrganizationsComponentConfig',
			success: (res) => {
				this.setState({
					isLazyLoadData: !!Number(res),
				});
			}
		});
	}

	/**
	 * 获取所有部门
	 */
	getOrganization = (organizationId = this.props.organizationId) => {
		const { configs = {}, origin = '', manageSceneFlag } = this.props;
		const departmentConfig = configs.department;
		const personConfig = configs.person;
		const { privilegeFilterFlag, privilegeIds } = departmentConfig || personConfig || {};
		const { appId, communityId, teamName, isLazyLoadData } = this.state;
		this.setState({ treeLoading: true });
		let api = '';
		if (isLazyLoadData) {
			api = '/org_v6/listOrganizationsByComponentV1';
		} else {
			api = '/org_v6/listOrganizationsByComponent';
		}

		this.setState({ treeLoading: true });
		origin === 'sales' ? callApi({
  		api: '/saleoppty/listGroupMembers',
  		data: {
  			groupId: communityId,
  		},
  		success: (res = []) => {
				const newArr = [];
				res.forEach((i) => {
					if (i) {
						i.targetId = i.userId;
						i.targetType = 'USER';
						newArr.push(i);
					}
				});
				const organizations = {
					contactInfoDTOS: newArr,
					name: teamName,
					id:organizationId
				};

				this.setState({
					organizations,
					treeLoading: false,
				});
  		},
  		error: () => {
  			this.setState({
  				treeLoading: false,
  			});
  		}
  	}) : callApi({
			api,
			data: {
				organizationId,
				componentType: componentType.ALL,
				appId,
				privilegeFilterFlag,
				privilegeIds,
				hiddenFilterFlag: configs.hiddenFilterFlag,
		  	manageSceneFlag: valueOfmanageSceneFlag(manageSceneFlag)
			},
			success: res => {
				const organizations = res.organizationTree;
				this.organizationMap.set(organizationId, organizations);
				organizations?.children?.forEach(item => {
					this.organizationMap.set(item.id, item);
				});
				this.setState({
					organizations: {
						...organizations,
					},
					treeLoading: false,
				});
			},
			error: () => {
				this.setState({ treeLoading: false });
			}
		});
	};

	lazyLoadOrganization = ({ allData, children }) => {
		if (children) {
			return Promise.resolve();
		}
		const { id: organizationId } = allData;
		if (!organizationId) {
			return Promise.reject();
		}
		const { configs = {}, manageSceneFlag } = this.props;
		const departmentConfig = configs.department;
		const personConfig = configs.person;
		const { privilegeFilterFlag, privilegeIds } = departmentConfig || personConfig || {};
		const appId = this.state.appId;
		return callApi({
			api: '/org_v6/listOrganizationsByComponentV1',
			data: {
				manageSceneFlag: valueOfmanageSceneFlag(manageSceneFlag),
				organizationId,
				componentType: componentType.ALL,
				appId,
				privilegeFilterFlag,
				privilegeIds,
				hiddenFilterFlag: configs.hiddenFilterFlag,
			},
			success: res => {
				const organizations = res.organizationTree;
				organizations?.children?.forEach(item => {
					this.organizationMap.set(item.id, item);
				});

				const currentOrg = this.organizationMap.get(organizationId);
				Object.assign(currentOrg, organizations);

				this.setState(({ organizations }) => ({
					organizations: {
						...organizations,
					}
				}));
			},
			error: () => {

			}
		});
	};

	/**
	 * 获取弹窗组件
	 */
	getComponent = (type) => {
		const { onChange, configs = {}, selectType, untrackStatus, isMultiply, manageSceneFlag } = this.props;
		const { organizations = {}, newSelects, disabledSelects, origin, isLazyLoadData } = this.state;
		const config = Object.assign({}, configs[type]);
		Reflect.deleteProperty(config, 'tabName');
		// console.log('selectType', selectType, type);
		const components = {
			person: (
				<SelectUser origin={origin} organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
				              addItems={this.addItems} removeItems={this.removeItems} selectType={selectType}
				              onChange={onChange} untrackStatus={untrackStatus} {...config} hiddenFilterFlag={configs.hiddenFilterFlag}
					isLazyLoadData={isLazyLoadData} lazyLoadOrganization={isLazyLoadData ? this.lazyLoadOrganization : undefined} />
			),
			user: (
				<SelectUser organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
				              addItems={this.addItems} removeItems={this.removeItems} selectType={selectType}
				              onChange={onChange} untrackStatus={untrackStatus} {...config} hiddenFilterFlag={configs.hiddenFilterFlag}
					isLazyLoadData={isLazyLoadData} lazyLoadOrganization={isLazyLoadData ? this.lazyLoadOrganization : undefined} />
			),
			department: (
				<SelectDepartment organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
				                  addItems={this.addItems} removeItems={this.removeItems}
				                  onChange={onChange} {...config} hiddenFilterFlag={configs.hiddenFilterFlag}
					isLazyLoadData={isLazyLoadData} lazyLoadOrganization={isLazyLoadData ? this.lazyLoadOrganization : undefined} />
			),
			userAndDepartment: (
				<SelectUserAndDept organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
					                addItems={this.addItems} removeItems={this.removeItems}
					                onChange={onChange} {...config} hiddenFilterFlag={configs.hiddenFilterFlag}
					isLazyLoadData={isLazyLoadData} lazyLoadOrganization={isLazyLoadData ? this.lazyLoadOrganization : undefined} />
			),
			position: (
				<SelectPosition organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
					              addItems={this.addItems} removeItems={this.removeItems}
					              onChange={onChange} hiddenFilterFlag={configs.hiddenFilterFlag} {...config}
					isLazyLoadData={isLazyLoadData}/>
			),
			level: (
				<SelectLevel organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
				            addItems={this.addItems} removeItems={this.removeItems}
					          onChange={onChange} {...config} />
			),
			label: (
				<SelectLabel organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
				            addItems={this.addItems} removeItems={this.removeItems}
					          onChange={onChange} {...config} />
			),
			business: (
				<SelectBusiness organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
					                        addItems={this.addItems} removeItems={this.removeItems}
					                        onChange={onChange} {...config} />
			),
			manager: (
				<SelectManager organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
					            addItems={this.addItems} removeItems={this.removeItems}
					            onChange={onChange} isLazyLoadData={isLazyLoadData} lazyLoadOrganization={isLazyLoadData ? this.lazyLoadOrganization : undefined} {...config} />
			),
			variable: (
				<SelectVariable
					organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
					addItems={this.addItems} removeItems={this.removeItems}
					onChange={onChange} {...config}
				/>
			),
			applierRelated: (
				<SelectApplierRelated
					organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
					addItems={this.addItems} removeItems={this.removeItems}
					onChange={onChange} {...config}
				/>
			),
			singlePerson: (
				<SelectSingleUser isMultiply={isMultiply} origin={origin} organizations={organizations} selects={newSelects} disabledSelects={disabledSelects}
					              addItems={isMultiply ? this.addItems : this.addSingleUser } removeItems={isMultiply ? this.removeItems : this.removeSingleUser}
					              onChange={onChange} isLazyLoadData={isLazyLoadData} lazyLoadOrganization={isLazyLoadData ? this.lazyLoadOrganization : undefined}
					{...config}/>
			)
			// company: (
			// 	<SelectCompany namespaceId={namespaceId} organizations={organizations} communityId={communityId} selects={newSelects}
			// 								 addItems={this.addItems} removeItems={this.removeItems} selectType={selectType}
			// 								 onChange={onChange} {...config} />
			// ),
			// building: (
			// 	<SelectBuilding namespaceId={namespaceId} organizations={organizations} communityId={communityId} selects={newSelects}
			// 								 addItems={this.addItems}
			// 								 onChange={onChange} {...config} />
			// ),
			// project: (
			// 	<SelectProject namespaceId={namespaceId} organizationId={organizationId}
			// 	               addItems={this.addItems} removeItems={this.removeItems} selectType={selectType}
			// 	               selects={newSelects} onChange={onChange} {...config} />
			// ),

		};
		const manageSceneFlagValue = valueOfmanageSceneFlag(manageSceneFlag);
		// 统一添加props
		return React.cloneElement(components[type], { manageSceneFlag: manageSceneFlagValue, changeItems: this.changeItems });
	};

	/**
	 * 获取tab名称
	 * */
	getTabName = (type) => {
		const { configs = {} } = this.props;
		const config = configs[type] || {};
		const names = {
			person: '选用户',
			user: '选用户',
			department: '选部门',
			userAndDepartment: '选部门/人',
			project: '选项目',
			position: '选岗位',
			level: '选职级',
			manager: '选部门负责人',
			business: '选业务责任部门',
			label: '选标签',
			company: '选公司',
			building: '选楼栋门牌',
			variable: '其他',
			applierRelated: '发起人相关',
			singlePerson: '选用户'
		};
		return config.tabName || names[type];
	};

	getTypeName = () => {
  	const { types = [] } = this.props;
  	const names = {
  		person: '组织架构',
  		user: '组织架构',
  		department: '组织架构',
  		userAndDepartment: '组织架构',
  		project: '项目',
  		position: '岗位',
  		level: '职级',
  		manager: '部门负责人',
  		business: '业务责任部门的',
  		label: '标签',
  		company: '公司',
  		building: '楼栋门牌',
  		variable: '其他',
  		applierRelated: '发起人相关'
  	};
  	return names[types[0]];
	};

	switchKind = (key) => {};

	onOk = () => {
		const { onOk = noop } = this.props;
		const { newSelects } = this.state;
		// 为了避免确认按钮被连续多次点击，当点击按钮时，设置loading，同时生成一个promise，promise成功或失败时取消loading。
		// if (newSelects.length < 1 || newSelects.length === disabledSelects.length) {
		// 	return message.warn('请添加人员');
		// }
		const { globalSingleSelect } = this.props;

		if (globalSingleSelect && newSelects.length > 1) {
			globalSingleSelectErrorMessage();
			return;
		}
		this.setState({ confirmLoading: true });
		const promise = new Promise((resolve, reject) => {
			onOk(newSelects, resolve, reject);
		});
		promise.then(() => {
			this.setState({ confirmLoading: false });
		}).catch(() => {
			this.setState({ confirmLoading: false });
		});
	};

	onCancel = () => {
		const { onCancel = noop, selects = [], disabledSelects = [] } = this.props;
		this.setState({ newSelects: selects, disabledSelects });
		onCancel();
	};

	// 增加单个用户
	addSingleUser = (newItems = []) => {
		const { onChange, types } = this.props;
		let newSelects = [];
		const obj = {};
		newSelects = newSelects.concat(newItems);
		newSelects = newSelects.reduce((pre, cur) => {
			if (types.length <= 1) {
				obj[Number(cur.sourceIdA)] ? noop() : 	obj[Number(cur.sourceIdA)] = true && pre.push(cur);
			} else {
				if (pre.some(item => Number(item.sourceIdA) === Number(cur.sourceIdA) && (item.flowUserSelectionType === cur.flowUserSelectionType) &&
        item.sourceTypeB === cur.sourceTypeB)) {
					noop();
				} else {
					pre.push(cur);
				}
			}
			return pre;
		}, []);
		this.setState({ newSelects });
		onChange ? onChange(newSelects) : noop();
	};

	// 添加数据
	addItems = (newItems = []) => {
		const { onChange, types, globalSingleSelect } = this.props;
		const selects = this.state.newSelects;
		let newSelects = selects.slice(0);
		const obj = {};
		/**
		 * 判断是否是全局单选，如果是全局单选，那么只能选择一个对象
		 *
		 */
		if (globalSingleSelect) {
			if (selects.length > 1 || newItems.length > 1) {
				globalSingleSelectErrorMessage();
				return;
			}
			newSelects = newItems;
		} else {
			newSelects = newSelects.concat(newItems);
		}
		newSelects = newSelects.reduce((pre, cur) => {
			if (types.length <= 1) {
				if (cur.sourceTypeA === 'source_user') {
					obj[`${cur.sourceIdA}`] ? noop() : obj[`${cur.sourceIdA}`] = true && pre.push(cur);
				} else {
					obj[`${cur.sourceIdB}-${cur.sourceIdA}`] ? noop() : obj[`${cur.sourceIdB}-${cur.sourceIdA}`] = true && pre.push(cur);
				}
			} else {
				if (pre.some(item => String(item.sourceIdA) === String(cur.sourceIdA) &&
				item.flowUserSelectionType === cur.flowUserSelectionType &&
				(item.sourceTypeA === 'source_user' ||
					item.sourceTypeB === undefined ||
					cur.sourceTypeB === undefined ||
					(item.sourceTypeB === cur.sourceTypeB &&
					String(item.sourceIdB) === String(cur.sourceIdB))))) {
					noop();
				} else {
					pre.push(cur);
				}
			}
			return pre;
		}, []);
		this.setState({ newSelects });
		onChange ? onChange(newSelects) : noop();
	};

	// 清除单独的用户
	removeSingleUser = (delItems = []) => {
		const { props } = this;
		const { onChange, types } = props;
		const selects = this.state.newSelects;
		let newSelects = selects.slice(0);
		delItems.forEach(value => {
			newSelects = newSelects.filter(select => {
				if (types.length <= 1) {
					return Number(select.sourceIdA) !== Number(value.sourceIdA);
				}
				return Number(select.sourceIdA) !== Number(value.sourceIdA) || select.flowUserSelectionType !== value.flowUserSelectionType;
			});
		});
		this.setState({ newSelects });
		onChange ? onChange(newSelects) : noop();
	};

	// 移除数据
	removeItems = (delItems = []) => {
		const { props } = this;
		const { onChange, types } = props;
		const selects = this.state.newSelects;
		let newSelects = selects.slice(0);
		newSelects = newSelects.filter(select => {
			if (types.length <= 1) {
				return !delItems.some(item => select.sourceIdA === item.sourceIdA);
			}
			return !delItems.some(item => select.flowUserSelectionType === item.flowUserSelectionType && select.sourceTypeA === item.sourceTypeA && String(select.sourceIdA) === String(item.sourceIdA) && select.sourceTypeB === item.sourceTypeB && (select.sourceTypeA === 'source_user' || select.sourceIdB === undefined || item.sourceIdB === undefined || String(select.sourceIdB) === String(item.sourceIdB)));
		});
		this.setState({ newSelects });
		onChange ? onChange(newSelects) : noop();
	};

	changeItems = (change) => {
		const { onChange } = this.props;
		const selects = this.state.newSelects;
		const newItems = change(selects);
		this.setState({ newSelects: newItems });
		onChange ? onChange(newItems) : noop();
	}
	// 清除全部
	clearAll = (mustSelects = []) => {
		const { onChange } = this.props;
		this.setState({ newSelects: mustSelects });
		onChange ? onChange(mustSelects) : noop();
	};

	render () {
		const { visible, title, types, zIndex = 1009, isModal, maskClosable, showName, mask, globalSingleSelect, manageSceneFlag: manageSceneFlagBool } = this.props;
		const manageSceneFlag = valueOfmanageSceneFlag(manageSceneFlagBool);
		const { confirmLoading, newSelects = [], loading, treeLoading, disabledSelects = [] } = this.state;

		const titleStr = title || (types.length === 1 && titleDict[types[0]]) || '选择';

		const resultBox = <ResultTable
			selects={newSelects}
			disabledSelects={disabledSelects}
			addItems={this.addItems}
			removeItems={this.removeItems}
			isSingleTab={types.length <= 1}
			clearAll={this.clearAll}
			showName={showName}
		/>;
		let nodes = <Row type='flex' align='stretch' className={`new-select-modal ${types.length === 1 ? 'select-one' : 'select-more'}`}>
			{types.length > 1
				? <Col span={24} className='new-selects-wrapper'>
					<Tabs type='card' onChange={key => this.switchKind(key)}>
						{types.map(type => (
							<TabPane tab={this.getTabName(type)} key={type}>
								{!visible ? null : <Row type='flex' align='stretch' className='select-more-wrapper'>
									<Col span={12}>
										{this.getComponent(type)}
									</Col>
									<Col span={12}>
										{resultBox}
									</Col>
								</Row>}
							</TabPane>
						))}
					</Tabs>
				</Col>
				: <Fragment>
					<Col span={12}>
						{!visible ? null : this.getComponent(types[0])}
					</Col>
					<Col span={12}>
						{resultBox}
					</Col>
				</Fragment>
			}
		</Row>;
		if (loading || treeLoading) {
			nodes = <div className='new-select-modal'><Spin className='select-content-spin'/></div>;
		}
		return (
			<React.Fragment>
				<SelectStore value={{ globalSingleSelect, manageSceneFlag }}>
					{ isModal
						? <Modal
							width={703}
							zIndex={zIndex}
							visible={visible}
							title={titleStr}
							mask={mask}
							confirmLoading={confirmLoading}
							onCancel={this.onCancel}
							onOk={this.onOk}
							destroyOnClose
						>
							{ nodes }
						</Modal>
						: <Drawer
							title={titleStr}
							width={800}
							zIndex={zIndex}
							mask={mask}
							placement="right"
							maskClosable={maskClosable}
							visible={visible}
							onClose={this.onCancel}
							className={'select-drawer'}
							destroyOnClose
						>
							{ nodes }
							<div className='select-bottom-btn'>
								<Button onClick={this.onCancel}>取消</Button>
								<Button onClick={this.onOk} type='primary' loading={confirmLoading}>确定</Button></div>
						</Drawer>
					}
				</SelectStore>
			</React.Fragment>
		);
	}
}

SelectModal.propTypes = {
	// 弹窗是否显示
	visible: PropTypes.bool,
	// 弹窗title，默认值为 '选择人员'
	title: PropTypes.string,
	namespaceId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	communityId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	organizationId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	// 弹窗的z-index
	zIndex: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	//不可选择列表
	disabledSelects: PropTypes.array,
	// 选择类型：checkbox（默认） 多选，radio 单选。
	selectType: PropTypes.string,
	// 弹窗所包含的类型，默认值['person']
	// 可选项：person 单个选择人员，user 选择部门的人员，department 选择部门，project 选择项目，position 选择岗位，manager 选择经理，etc 选择其他（变量）
	types: PropTypes.array,
	// 每个类型的自定义配置项
	// {person: {
	// 	tabName: '自定义名称',
	//  disabledTip: 禁用提示语
	// }}
	configs: PropTypes.object,
	// 组件的已选列表，统一的数据格式：
	// [{selectionName: ${显示名称}, flowUserSelectionType: ${所选的类型}, sourceIdA: ${所选数据的ID A}，sourceTypeA: ${所选数据的type A, sourceIdB: ${所选数据的ID B}，sourceTypeB: ${所选数据的type B}，isSearchFromExist：${是否从当前数据中进行搜索}}]
	// 目前岗位和经理用到了sourceIdB 和 sourceTypeB
	// 只有singlePerson使用了isSearchFromExist
	selects: PropTypes.array,
	// 改变组件已选列表的回调，会传入修改后的selects
	onChange: PropTypes.func,
	// 点击确定时的回调函数，会传入修改后的selects和一个promise成功和失败的回调
	onOk: PropTypes.func,
	// 点击取消时的回调函数
	onCancel: PropTypes.func,
	// 是否Modal显示 默认为true。为false时是抽屉模式
	isModal: PropTypes.bool,
	// 是否显示mask
	mask: PropTypes.bool,
	// 是否展示左上角组件名字，默认展示
	showName: PropTypes.bool,
	//全局单选模式,多tab单选
	globalSingleSelect: PropTypes.bool,
	// 按照管理员管理范围
	manageSceneFlag: PropTypes.bool
};

SelectModal.defaultProps = {
	selectType: 'checkbox',
	types: ['person'],
	isModal: false,
	loading: false,
	maskClosable: true,
	showName: true,
	mask: true,
	globalSingleSelect: false,
	manageSceneFlag: false,
};

export default SelectModal;
